import { apiClient } from './apiClient';

export const chaosEffectsWidgetApi = {
  create: () => apiClient.post('/dashboard/chaos-effects-widget'),
  get: () => apiClient.get('/dashboard/chaos-effects-widget'),
  update: (id, payload) => apiClient.patch(`/dashboard/chaos-effects-widget/${id}`, payload)
};
